<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_1246_5488)">
                        <path d="M29.4039 6.27336C23.7017 5.61371 20.5709 3.99455 18.2138 0.504383C18.1038 0.348431 17.9583 0.221273 17.7895 0.133529C17.6207 0.0457841 17.4335 0 17.2436 0C17.0537 0 16.8665 0.0457841 16.6977 0.133529C16.529 0.221273 16.3835 0.348431 16.2734 0.504383C13.6544 3.94658 10.4284 5.63769 5.04761 6.27336C4.75725 6.30871 4.48997 6.45052 4.29676 6.67173C4.10354 6.89294 3.99792 7.17807 4.00003 7.47273V11.9704C4.00003 21.0016 9.10699 27.0105 16.5948 30.9564C16.784 31.0756 17.0026 31.1387 17.2257 31.1387C17.4489 31.1387 17.6675 31.0756 17.8567 30.9564C19.7614 29.6971 22.8565 28.054 24.4279 26.3988C26.3414 24.5316 27.8612 22.2944 28.8962 19.8214C29.9312 17.3483 30.4602 14.6903 30.4515 12.0064V7.46074C30.4507 7.16814 30.3437 6.88594 30.1508 6.66725C29.9578 6.44856 29.6922 6.30847 29.4039 6.27336ZM20.2375 26.6627L17.2257 28.5457C15.4231 27.5249 13.7035 26.3619 12.0831 25.0675C12.1958 24.3334 12.5164 23.6476 13.0062 23.0924C13.4961 22.5372 14.1345 22.1361 14.8449 21.9372C15.0544 21.8818 15.2449 21.7698 15.3959 21.6135C15.547 21.4571 15.6528 21.2621 15.702 21.0496C15.9639 20.0062 14.5116 19.5504 14.6663 18.5309V14.7769C14.6725 14.3081 14.8601 13.8602 15.1892 13.5286C15.5182 13.1971 15.9628 13.008 16.4282 13.0018H18.0472C18.5093 13.0112 18.9496 13.202 19.2742 13.5335C19.5988 13.8651 19.7822 14.3112 19.7852 14.7769V18.5309C19.9161 19.5624 18.4995 19.9942 18.7614 21.0376C18.8077 21.2509 18.9109 21.4473 19.0598 21.6058C19.2088 21.7643 19.3978 21.8789 19.6066 21.9372C20.321 22.1342 20.9623 22.5381 21.4511 23.0988C21.9399 23.6595 22.2547 24.3523 22.3565 25.0915C21.6976 25.6808 20.9885 26.2105 20.2375 26.6747V26.6627Z" fill="#265D91"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_1246_5488" x="0" y="0" width="34.4531" height="39.1388" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1246_5488"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1246_5488" result="shape"/>
                        </filter>
                        </defs>
                        </svg>
                        
                        Mode de paiement
                </h1>

                <!--begin::Menu-->
              
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Paramètres</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Mode de paiement</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card headeer-->
        
          <div class="card-body ">
          <div class="action-grid mb-10">
            <div class="title">
                <h4>Liste des cartes </h4>
               </div>
               <div class="change-offre">
                <a  (click)="CheckoutAddCard()">Ajouter Carte</a>
               </div>
          </div>
          <div class="container">
            <div class="row mb-3">
                <div class="col-lg-3">
                    <div class="input-group mb-3">
                        <input
                          type="text"
                          data-kt-customer-table-filter="search"
                          [(ngModel)]="searchElement" (keyup.enter)="applyFilter()"
                          class="form-control form-control-solid ps-15"
                          placeholder="Rechercher"
                        />
                        <div class="input-group-append">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                              fill="#7E7C7C"
                            />
                          </svg>
            
                          <button
                            class="input-group-text cursor-pointer"
                            id="basic-addon2"
                            (click)="applyFilter()"
                          >
                            <span>Rechercher</span>
                          </button>
                        </div>
                      </div>
                </div>
                <div class="col-lg-3 ">
                      
                          </div> 
                          <div class="col-lg-3 ">
                      
                          </div> 
                <div class="col-lg-3">
                 
                   
                </div>
               
            </div>
         
            <div class="table-responsive mt-15">
                <table class="table align-middle fs-6 gy-5 style-table" id="list_cra">
                    <thead>
                        <th class="min-w-125px">
                            <span>Carte</span>
                        </th>
                        <th class="min-w-125px">
                            <span>Numéro de carte</span>
                        </th>
                        <th class="min-w-125px">
                           <span> Date d'expiration</span>
                        </th>
                        <th class="min-w-125px">
                            <span>Email</span>
                        </th>
                        <!-- <th class="bg2 min-w-125px">
                            Facture
                        </th> -->
                        <!-- <th class="bg4 min-w-125px">
                            Historique
                        </th> -->
                        <th class="min-w-125px">
                            <span>Actions</span>
                        </th>
                    </thead>
                 <tbody>
                    <tr *ngFor="let listCard of listCards">
                        <td>
                            <span class="first-td">{{listCard?.card?.display_brand}}</span>
                        </td>
                        <td>
                            <span>**** **** **** {{listCard?.card?.last4}}
                                <img *ngIf="listCard?.card?.display_brand === 'visa'" src="/assets/media/cards/visa-icon.png" width="30">
                                <img *ngIf="listCard?.card?.display_brand === 'discover'" src="/assets/media/cards/Discover-icon.png" width="30">
                                <img *ngIf="listCard?.card?.display_brand === 'mastercard'" src="/assets/media/cards/mastercard-icon.png" width="30">
                            </span>
                        </td>
                    <td>
                        <span>{{listCard?.card?.exp_month}}/{{listCard?.card?.exp_year}}
                        </span>
                    </td>
                    <td>
                        <span>{{listCard?.billing_details?.email}}
                        </span>
                       
                    </td>
                    <!-- <td>
                        <a href="#"><i class="fa-solid fa-cloud-arrow-down" style="color:#265D91;font-size: 20px;"></i></a>
                    </td> -->
                    <td>
                        <i class="fa-solid fa-trash deleteIcon" (click)="removeCard(listCard.id)"></i>
                    </td>
                    </tr>
                 </tbody>
    
                </table>
             </div>
          
        <div class="alert alert-warning text-center mt-5" role="alert"
        *ngIf="listCards && !listCards.length">
             <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
             <span class="empty-list">
                 La liste est vide
             </span>
         </div>
          </div>
        
           
          </div>
        </div>
     
    </div>
    <!--end::Content container-->
</div>

